export default {
  Java: `import java.util.Scanner;
  public class largestPrime {
      static long runner(long n) {
          long prime = 2L;
              while (n >= prime){
                  if (n % prime == 0){
                      n = (n/prime);
                  }else{
                      prime++;
                  }
              }
              return prime;
          }
              
      public static void main(String args[]) {
          System.out.println(runner(600851475143L));
      }
  }`,
  JavaScript: `function runner(n){
        let prime = 2,
        while (n >= prime) {
          if (n % prime === 0) {
            n = n / prime;
          } else {
            prime++;
          }
        }
        console.log(prime)
}
runner(600851475143)`,
  Python: `def runner(n):
  prime = 2
  while (n >= prime):
    if (n % prime == 0):
      n = n/prime
    else:
      prime += 1
  print(prime)    

runner(600851475143)
`,
};
